<template>
  <div>
    <v-form ref="formTratativa" @submit.prevent v-model="validTratativa">
      <v-container>
        <div class="header-step">
          <h3>Numero da solicitação: {{ protocolo }}</h3>
          <h3>Transportador: {{ nomeTransportador }}</h3>
        </div>
        <div>
          <h4 class="header-step">Data da abertura: {{ formatarData(dataAbertura) }}</h4>
          <h4 class="header-step">Autor: {{ autor }}</h4>
          <br>
          <v-divider></v-divider>
        </div>
        <template >
          <div class="mb-2 mt-2">
            <div class="valorPremio">
              Prêmio: {{ model.novoSeguro != undefined ? toMoneyString(model.novoSeguro.premioTotal) : "-" }}
            </div>
            <div 
              class="taxaDesconto" 
              v-if="exibeTaxa()"
            >
              Taxa: {{ model.novoSeguro != undefined ? toPercentTaxaString(model.novoSeguro.taxaDesejada) : "-" }} / Desconto: {{ model.novoSeguro != undefined ? toPercentString(model.novoSeguro.descontoCalculado) : "-"}}
            </div>
            <div 
              style="font-size: 15px" 
              v-else
            >
              Taxa: {{ model.novoSeguro != undefined ? toPercentTaxaString(model.novoSeguro.taxaCalculada) : "-" }} / Desconto: {{ model.novoSeguro != undefined ? toPercentString(model.novoSeguro.descontoDesejado) : "-"}}
            </div>
          </div>
        </template>
        <v-divider></v-divider>
        <template>
          <v-flex v-for="(inconsistencia) in inconsistenciaAgrupadas" :key="inconsistencia.id" class="mt-2 mb-2">
            <v-list-tile class="error lista-inconsistencias" id="idInconsistencia">
              <v-list-tile-avatar v-if="!$vuetify.breakpoint.smAndDown">
                <v-icon large color="white">warning</v-icon>
              </v-list-tile-avatar>
              <v-flex xs12 sm12 lg8>
                <v-list-tile-content 
                  v-if="inconsistencia.tipoInconsistencia.id === inconsistenciasComputed.inconsistenciasEnum.VALOR_PREMIO_ACIMA_LIMITE 
                  || inconsistencia.tipoInconsistencia.id === inconsistenciasComputed.inconsistenciasEnum.TAXA_SINISTRALIDADE_ACIMA_LIMITE 
                  || inconsistencia.tipoInconsistencia.id === inconsistenciasComputed.inconsistenciasEnum.PROPOSTA_EXPIRADA" 
                  class="white--text">
                    {{ montaMensagemInconsistencia(inconsistencia.inconsistencia) }}
                </v-list-tile-content>
                <v-list-tile-content v-else class="white--text">
                  {{ inconsistencia.tipoInconsistencia.descricao }}: {{ montaMensagemInconsistencia(inconsistencia.inconsistencia) }}
                </v-list-tile-content>
              </v-flex>
            </v-list-tile>
          </v-flex>
        </template>
        <v-layout row wrap>
          <div>
            <h2 class="margem mb-2">Nova tratativa</h2>
            
            <v-flex v-if="exibeStatus()">
              <h3 class="margem">Status</h3>
              <v-select
                class="margem"
                label="Selecione uma opção"
                :items="getStatusList"
                v-model="parecerModel.status"
                :item-text="exibeTextoStatus"
                return-object
                required
                :rules="regras.notNull"
              >
              </v-select>
            </v-flex>
          </div>
        </v-layout>
        <v-layout row wrap>
          <h3 class="margem">Escrever tratativa</h3>
          
        </v-layout>
        <v-layout row wrap>
          <v-flex>
            <v-textarea v-model="parecerModel.descricao"></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <template>
            <v-btn 
              :disabled="desabilitaAnexo()" 
              :class="classeBotaoAnexo" 
              @click="abrirDialogAnexarArquivoTratativa()" 
              flat
            >
              ANEXAR ARQUIVOS
              <v-icon>attach_file</v-icon>
            </v-btn>
            <v-layout v-if="arquivoAnexado != null">
              <v-flex>
                ({{ arquivoAnexado.length }} anexo(s))
                <v-btn flat icon @click="removeAnexos()">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </template>
          <v-spacer></v-spacer>
          <template>
            <v-btn 
              :disabled="!parecerModel.descricao"
              :class="classeBotaoEnviar"
              @click="insereParecer()"
              flat
            >
              ENVIAR TRATATIVA
            </v-btn>
          </template>
        </v-layout>
        <br>
        <v-divider></v-divider>
        <v-layout row wrap>
          <span class="branco">/n</span>
          <span class="branco">/n</span>
        </v-layout>

        <v-layout row wrap>
          <div>
            <h3 class="margem mb-2">Histórico de tratativas</h3>
          </div>
        </v-layout>
        <v-divider></v-divider>
        <br>

        <v-flex xs12 pb-3>
          <v-expansion-panel expand>
            <v-expansion-panel-content v-for="(parecer) in parecerTecnico" :key="parecer.dataCriacao">
              <div slot="header">
                  {{ parecer.nomeUsuarioAutor }} {{ "( " + traduzirPerfil(parecer.idPerfil) + " )"}} -  {{ parecer.dataCriacao }}
              </div>
              <div v-for="(nomeAnexo) in parecer.arquivoAnexado" :key="nomeAnexo.nomeArquivo">
                <div  class="ml-4 mb-2">
                    <a @click="downloadArquivo(nomeAnexo.id, parecer.nomeUsuarioAutor)" >
                      <v-icon>attachment</v-icon>
                      {{ nomeAnexo.nomeArquivo }} - {{ nomeAnexo.tipoProposta.descricao }}
                    </a>
                  </div>
                
              </div>
              <div class="ml-4 mb-2">
                {{ parecer.status }}
                <br>
                {{ parecer.descricao }}
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>

        <template>
          <v-layout row justify-center>
            <v-dialog persistent v-model="dialogAnexarArquivoTratativa" max-width="500px" >
              <ModalAnexarArquivoTratativa
                v-if="dialogAnexarArquivoTratativa"
                :dialog="dialogAnexarArquivoTratativa"
                :model="model"
                @fechar="dialogAnexarArquivoTratativa = false"
                @arquivoAnexado="getArquivoAnexado"
              />
            </v-dialog>
          </v-layout>
        </template>

        <template>
          <v-layout row justify-center>
            <v-dialog v-model="modalAceitePropostaAssinada" max-width="550px" persistent>
              <v-card>
                <v-card-title class="title  justify-space-between primary--text">
                  <span> &nbsp; O aceite da proposta foi enviado.</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <div> <big>O seguro ainda não foi efetivado, é necessário aguardar a confirmação da cobertura.</big></div>
                  </v-container>
                </v-card-text>
                <br>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn id="btnConfirmaCienciaAceiteProposta"
                    color="primary"
                    @click="modalAceitePropostaAssinada = false">ESTOU CIENTE
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </template>

      </v-container>
    </v-form>
    <v-snackbar
      :timeout="6000"
      :color="snackbarParecer.sucesso ? 'success' : 'error'"
      multi-line
      v-model="snackbarParecer.visivel">
      {{ snackbarParecer.mensagem }}
      <v-btn dark flat @click.native="snackbarParecer.visivel = false">Fechar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import permissoes from '@/helpers/permissoes.js'
import inconsistencias from '@/helpers/inconsistencias'
import CustomFormat from '@/helpers/custom-format'
import EStatus from '@/helpers/estatus'
import perfilHelper from '@/helpers/perfil'
import ModalAnexarArquivoTratativa from "@/components/pages/questionario-analise-riscos/ModalAnexarArquivoTratativa.vue";


export default {
  name: "Tratativas",
  components: {
    ModalAnexarArquivoTratativa
},
  props: {
    protocolo: String,
    nomeTransportador: String,
    dataAbertura: String,
    autor: String,
    model: {},
    lstStatus: {},
    dadosQuestionarioCompleto: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    listaPerfis: [],
    validTratativa: true,
    tipoTratativa: null,
    tratativas: [],
    parecerTecnico: [],
    listaFiltrada: false,
    lstStatusFiltrada: {},
    parecerModel: {
      idQuestionario: '',
      status: [{}],
      descricao: '',
      nomeUsuarioAutor: '', 
      temArquivo: false, 
    },
    questionarioModel: null,
    mapaPermissoes: null,
    arquivoValido: true,
    arquivoAnexado: null,
    descricaoEnvio: '',
    dialogAnexarArquivoTratativa: false,
    modalAceitePropostaAssinada: false,
    enviandoArquivo: false,
    dialogFile: false,
    arquivo: [],
    snackbarParecer: {
      visivel: false,
      sucesso: true,
      mensagem: ''
    },
    loading: false,
    urlEnviaProposta: `${process.env.URL_QUESTIONARIOMS}/v1/enviaConjuntoArquivo`,
    regras: {
      notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      cep: [v => !!String(v).match(/^\d{8}$/) || "CEP incorreto"],
      length: len => v =>
        (v || "").length <= len ||
        `Número máximo de caracteres ultrapassado, requer no máximo ${len} caracteres.`
    }
  }),
  watch: {
    dadosQuestionarioCompleto(value) {
      if(value.id != null  &&  value.id != undefined) {
        value.pareceres.forEach(element => {
          this.parecerTecnico.push({
              id:element.id,
              dataCriacao: this.formatDate(element.dataCriacao), 
              status: element.status.statuscliente,
              descricao: element.descricao, 
              nomeUsuarioAutor: element.nomeUsuarioAutor,
              arquivoAnexado: element.arquivoAnexado,
              idPerfil: element.idPerfil, 
              temArquivo: element.temArquivo,
              tratativaVista: element.tratativaVista,
             });
          
        });
        setTimeout(() => {
          this.mudarVisualizadoDoParecer();
        }, 5000);
        
      }
    }
  },
  computed: {
    eStatusComputed: function () {
      return EStatus;
    },
    classeBotaoAnexo() {
      return this.protocolo 
        ? 'button-disabled'
        : 'button'
    },
    classeBotaoEnviar() {
      return !this.parecerModel.descricao 
        ? 'button-permanecer-disabled'
        : 'button-permanecer'
    },
    classeBotaoAnexo() {
      if (this.model.status != undefined) {
        return  (this.model.status.id == this.eStatusComputed.statusEnum.PENDENTE || this.model.status.id == this.eStatusComputed.statusEnum.PROCESSAMENTO)
          ? 'button-permanecer-disabled'
          : 'button-anexar'
      }
    },
    inconsistenciasComputed() {
      return inconsistencias;
    },
   
    inconsistenciaAgrupadas() {
      const self = this;
      var result = [];
      
      if (self.model.inconsistencias != undefined) {
        self.model.inconsistencias.reduce(function (res, value) {
          if (!res[value.tipoInconsistencia.id]) {
            res[value.tipoInconsistencia.id] = {
              inconsistencia: [],
              tipoInconsistencia: value.tipoInconsistencia,
              idStatusSolicitacao: value.tipoInconsistencia.id
            };
            result.push(res[value.tipoInconsistencia.id])
          }
          res[value.tipoInconsistencia.id].inconsistencia.push(value);
          return res;
        }, {});
      }

      return result;
    },
    
    getStatusList: function () {
      if (this.listaFiltrada == false && this.lstStatus != null && this.model.status) {
        this.lstStatusFiltrada = this.lstStatus.filter((status) => {

          if (status && status.id == this.model.status.id) {
            this.parecerModel.status = [ status ];
          }

          if (usuarioHelper.USUARIO_LOGADO().perfil.id != perfilHelper.ADMINISTRADOR &&
          usuarioHelper.USUARIO_LOGADO().perfil.id != perfilHelper.ANALISTA) {
            return status.id == EStatus.statusEnum.AGUARDANDO_EFETIVACAO ||
            status.id == EStatus.statusEnum.PROPOSTA_CONTESTADA ||
            status.id == this.model.status.id ?
              true : false;
          }
          return status.id != EStatus.statusEnum.PROCESSAMENTO &&
            status.id != EStatus.statusEnum.DIRECIONAMENTO_COMERCIAL ?
              true : false;
          })
          .sort((a, b) => {
            return a.ordem - b.ordem;
          });
  
        this.processaStatusList();
        this.listaFiltrada = true;
      } 

      if (this.lstStatusFiltrada != null && this.parecerModel.status != undefined) {
        return this.lstStatusFiltrada;
      }
    },
  },
  mounted() {
    this.buscaPerfisUsuario();
  },
  methods: {
     obterIdsComTratativaVistaFalsa(objetos) {
      const ids = [];
      
      for (const objeto of objetos) {
        if (objeto.tratativaVista == false) {
          ids.push(objeto.id);
        }
      }
      return ids;
    },
    async mudarVisualizadoDoParecer()  {
      if( this.parecerTecnico != null && this.parecerTecnico.length > 0 ) {
        const listagemParecer = this.obterIdsComTratativaVistaFalsa(this.parecerTecnico);
        if(listagemParecer.length > 0) {

          await axios.post( `${process.env.URL_QUESTIONARIOMS}/v1/parecerVisualizado`, this.obterIdsComTratativaVistaFalsa(this.parecerTecnico),
          {
            headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` },
          })
        }
      }
    
  
    },
    downloadArquivo(arquivo, nome) {
        const self = this;
        if(arquivo != null) {
          self.$store.commit('startLoading');

          axios.get(
              `${process.env.URL_QUESTIONARIOMS}/v1/no-auth/downloadArquivo?id=${arquivo}&transportadoraNome=${nome}`,
              {
                responseType: "arraybuffer",
                headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` },
              })
            .then((response) => {
            
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(new Blob([response.data], { type: "application/octet-stream" }));
              link.download = response.headers.nomearquivo;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              self.$store.commit('endLoading');

            })
            .catch((error) => {
              this.snackbarParecer.sucesso = false;
            this.snackbarParecer.visivel = true;
            this.snackbarParecer.mensagem = error.response.data.message;
            }).finally(() => {
              self.$store.commit('endLoading');
              
            })
        } else {
          this.snackbarParecer.sucesso = false;
            this.snackbarParecer.visivel = true;
            this.snackbarParecer.mensagem = "Arquivo ainda nao foi processador pelo servidor.";
        }
       
    },
    traduzirPerfil(id) {
      const perfil = this.listaPerfis.find(
        item => item.id === id
      );
      return perfil ? perfil.descricao : "";
    },
    buscaPerfisUsuario() {
      axios.get(`${process.env.URL_USUARIOMS}/v1/buscaPerfis`, {
        headers: {
          'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      }).then(response => {
        return response.data;
      }).then(data => {
        this.listaPerfis = data;
      }).catch(err => {
        this.snackbarParecer.mensagem = 'Erro ao buscar listagem de perfis'
        this.snackbarParecer.sucesso = false;
        this.snackbarParecer.visivel = true;
      })
    },
     formatDate(dateString) {
  const date = new Date(dateString);
  
  const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth()+1).padStart(2, "0")}/${date.getFullYear()}`;
  
  const formattedTime = `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
  
  return `${formattedDate}, ${formattedTime}`;
},
    toMoneyString: function (value) {
      return CustomFormat.toMoneyString(value);
    },
    toPercentString: function (value) {
      return CustomFormat.toPercentString(value)
    },
    toPercentTaxaString: function (value) {
      return CustomFormat.toPercentTaxaString(value)
    },
    toLocaleDateTimeString: function (value) {
      return CustomFormat.toLocaleDateTimeString(value);
    },
    montaMensagemInconsistencia: function (array) {
      return array.map((x) => { return x.descricao; }).join(', ');
    },
    processarArquivo(event) {
      this.arquivo = [];
      for (const file of event.target.files) {
        this.arquivo.push(file);
      }
    },

    getArquivoAnexado(value) {
      if (value && this.arquivoAnexado != null) {
        this.arquivoAnexado.push(...value)
      } else if (value) {
        this.arquivoAnexado = value
      }
    },
    removeAnexos() {
      this.arquivoAnexado = null
    },
    exibeTaxa() {
      if (this.model.novoSeguro != undefined) {
        if (this.model.novoSeguro.taxaDesejada != null) {
          return true
        }
      }
    },

    exibeTextoStatus: status => usuarioHelper.USUARIO_LOGADO().perfil.id == perfilHelper.ADMINISTRADOR ||
                              usuarioHelper.USUARIO_LOGADO().perfil.id == perfilHelper.ANALISTA 
                              ? Array.isArray(status) ? status[0].descricao : status.descricao
                              : Array.isArray(status) ? status[0].statuscliente : status.statuscliente,

    exibeStatus() {
      if (this.model.status != undefined) {
        if (this.model.status.id == this.eStatusComputed.statusEnum.PROCESSAMENTO) {
          return false
        } else if (usuarioHelper.USUARIO_LOGADO().perfil.id != perfilHelper.ADMINISTRADOR &&
                   usuarioHelper.USUARIO_LOGADO().perfil.id != perfilHelper.ANALISTA &&
                   this.model.status.id == this.eStatusComputed.statusEnum.AGUARDANDO_CLIENTE) {
          return true
        } else if (usuarioHelper.USUARIO_LOGADO().perfil.id != perfilHelper.ADMINISTRADOR &&
                   usuarioHelper.USUARIO_LOGADO().perfil.id != perfilHelper.ANALISTA) {
          return false
        } else {
          return true
        }
      }
    },
    insereParecer() {
      const self = this;

      if (this.parecerModel.status[0].id == this.eStatusComputed.statusEnum.AGUARDANDO_EFETIVACAO &&
          this.arquivoAnexado == null) {
        this.snackbarParecer.mensagem = 'É obrigatório anexar a proposta assinada.'
        this.snackbarParecer.sucesso = false;
        this.snackbarParecer.visivel = true;
        return
      }

      self.parecerTecnico.unshift({
        idPerfil: usuarioHelper.USUARIO_LOGADO().perfil.id,
        status: 'Alterou o status para ' + self.parecerModel.status[0].descricao,
        descricao: self.parecerModel.descricao,
        nomeUsuarioAutor: usuarioHelper.USUARIO_LOGADO().nome,
        dataCriacao: self.formatarDataHora(new Date()),
        arquivoAnexado: this.arquivoAnexado
      })

      self.parecerModel.idQuestionario = self.model.id;
      self.parecerModel.nomeUsuarioAutor = usuarioHelper.USUARIO_LOGADO().nome;
      self.parecerModel.status = self.parecerModel.status[0];
      self.parecerModel.descricao = self.parecerModel.descricao;
      self.parecerModel.temArquivo = self.arquivoAnexado != null && self.arquivoAnexado.length > 0;
      self.parecerModel.idPerfil = usuarioHelper.USUARIO_LOGADO().perfil.id;
      const statusSelecionado = self.parecerModel.status;

      self.snackbarParecer.mensagem = 'Parecer incluído com sucesso.';

      self.$store.commit('startLoading');
      self.loading = true;
      let idParecer = null;
     

      axios.post(`${process.env.URL_QUESTIONARIOMS}/v1/insereParecer`, self.parecerModel, {
        headers: {
          'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      }).then(response => {
        return response.data;
      }).then(data => {
        self.resetParecerModel();
        self.parecerModel.status = [ statusSelecionado ];
        self.atualizaStatusList();
        if (self.arquivoAnexado != null) {
          idParecer = data;
        
        }
      })
      .catch((err) => {
        console.log(err)
        self.snackbarParecer.mensagem = 'Algo de inesperado aconteceu.'
        self.snackbarParecer.sucesso = false;
        self.snackbarParecer.visivel = true;
      }).finally(() => {
        console.log(idParecer);
        self.enviaArquivos(idParecer);
        self.arquivoAnexado = null;
      })
    
      self.$store.commit('endLoading');
      self.loading = false; 

      self.snackbarParecer.visivel = true;
      self.snackbarParecer.sucesso = true;
    },

    processaStatusList: function () {
      const self = this;
        for (var i = 0; i < self.lstStatusFiltrada.length; i++) {
          self.lstStatusFiltrada[i] = [ self.lstStatusFiltrada[i] ];
        }
      
    },

    desabilitaAnexo() {
      if (this.model.status != undefined) {
        if (this.model.status.id == this.eStatusComputed.statusEnum.PENDENTE || this.model.status.id == this.eStatusComputed.statusEnum.PROCESSAMENTO) {
          return true
        }
      }
    },
    enviaArquivos: function(idParecer) {
      var arquivoList = [];
      var formData = new FormData();
      var url = null;

      this.arquivoAnexado.forEach(e => arquivoList.push(e));

      formData.append('arquivoList', JSON.stringify(arquivoList));
      formData.append('parecer', this.parecerModel.descricao);
      formData.append('idParecer', idParecer);
      formData.append('idConjuntoArquivo', null);
      formData.append('transportadoraNome', this.nomeTransportador);
      formData.append('usuarioPerfil', usuarioHelper.USUARIO_LOGADO().perfil.id);
      formData.append('usuarioNome', usuarioHelper.USUARIO_LOGADO().nome);

      url = this.urlEnviaProposta +  `?idParecer=${idParecer}`;

      if (this.parecerModel.status.id == this.eStatusComputed.statusEnum.AGUARDANDO_EFETIVACAO) {
        this.modalAceitePropostaAssinada = true
      }
    
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`);

      xhr.send(formData);
    },

    fecharDialogAnexarArquivoTratativa() {
      this.dialogAnexarArquivoTratativa = false;
    },

    abrirDialogAnexarArquivoTratativa() {
      this.dialogAnexarArquivoTratativa = true;
    },

    formatarData(data) {
      return new Date(data).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "numeric",
        day: "numeric"
      });
    },
    formatarDataHora(datetime) {
      return CustomFormat.toLocaleDateTimeString(datetime);
    },
    atualizaStatusList: function () { //Remove os status anteriores ao da solicitação.
      const self = this;
      var statusClienteRepetido = [];
      self.lstStatusFiltrada = self.lstStatusFiltrada.filter((status) => {
          return status[0].ordem >= self.parecerModel.status[0].ordem;
      })
      .sort(function(a, b){
          return a[0].ordem - b[0].ordem;
      });
    },
    resetParecerModel: function() {
      this.parecerModel = {
        idQuestionario: '',
        status: [{}],
        descricao: '',
        nomeUsuarioAutor: ''
      }
    }
  }
};
</script>

<style>
@import "../../../css/estilos.css";

.margem {
  margin-left: 3mm;
  justify-content: left;
  color: #656565;
}

.bordas {
  border: solid 1px;
  border-bottom: none;
}
.bordas2 {
  border: solid 1px;
  border-top: none;
  border-bottom: none;
}

.bordas3 {
  border: solid 1px;
  border-top: none;
}

.branco {
  color: white;
}

.button-permanecer {
  background: #00456e;
  color: #fff !important;
}

.button-anexar {
  background: #40bccc;
  color: #fff !important;
}

.button-permanecer-disabled {
  background-color: #e0e0e0;
}

.button {
  background-color: #2bb4b6;
  color: #fff !important;
}

.button-disabled {
  background-color: #e0e0e0;
}

.button-custom-label {
  width: 100%;
  min-width: 100px;
  text-align: center;
  color: #fff !important;
  background-color: #2bb4b6;
  border-radius: 2px;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}

.header-step {
  color: #656565;
}

.margemTopo{
  margin-top: 10px;
  justify-content: left;
}

.valorPremio {
  font-size: 21px;
  color: #00456e;
  font-weight: bold;
}

.taxaDesconto {
  font-size: 17px;
  color: #656565;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/Tratativas.vue